import { Translatable } from '@fmnts/api/shared';
import { IFieldCondition } from '../api-model/condition';
import { FormFieldset } from './form-fieldset';
import { QuizField } from './quiz-field';

interface IQuizFieldset {
  key: string;
  fields: QuizField[];
  label: Translatable<string> | string | undefined;
  condition?: IFieldCondition | undefined;
}

export class QuizFieldset extends FormFieldset {
  override fields: QuizField[];

  constructor(dto: Readonly<IQuizFieldset>) {
    super(dto);
    this.fields = dto.fields;
  }
}
